import React from "react";
import classes from "../FitnessPreview.module.scss";
import EquipmentsSvg from "./EquipmentsSvg";
import MusclesTargetSvg from "./MusclesTargetSvg";
import { flatMap, uniq } from "lodash";

const EquipmentAndMuscles = ({ wellnessDays = [] }) => {

    const equipmentNames = uniq(
        flatMap(wellnessDays, day => day.instance?.equipmentNames || [])
    )

    const muscleNames = uniq(
        flatMap(wellnessDays, day => day.instance?.muscles || [])
    )

    const equipmentArray = Array.from(equipmentNames);
    const muscleArray = Array.from(muscleNames);

    return (
        <div className={classes.equipmentAndMuscles}>

            <div className={classes.row}>
                <div className={classes.svg}><EquipmentsSvg /></div>
                <div className={classes.container}>
                    <div className={classes.title}>Equipment</div>
                    <div className={classes.items}>
                        {equipmentArray.join(", ")}
                    </div>
                </div>
            </div>
            <div className={classes.row}>
                <div className={classes.svg}><MusclesTargetSvg /></div>
                <div className={classes.container}>
                    <div className={classes.title}>Muscles Target</div>
                    <div className={classes.items}>
                        {muscleArray?.map((item, index) => (
                            <span key={index}>
                                {item}
                                {index < muscleArray.length - 1 && ", "}
                            </span>
                        ))}
                    </div>
                </div>

            </div>
        </div>
    );
};

export default EquipmentAndMuscles;
